import { ValueOf } from '../../utilities';

/** Theme that user would like to use. This only works for the GraphQL interface for now. */
export type UserSettingsTheme = ValueOf<typeof UserSettingsTheme>;

/**
 * Theme that user would like to use. This only works for the GraphQL interface for now.
 *
 * @note This is used with the above type because `enum` does not support `null` as a value.
 */
export const UserSettingsTheme = {
  dark: 'dark',
  light: 'light',
  system: null
} as const;
